export const formatPrice = (price?: number | null): string => (price ?? 0).toLocaleString("de-DE", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
